export default __webpack_public_path__ + "static/media/character-1.9d0bfca7.png";